import { useDatabaseSyncWrapperStore } from "@/components/contexts/databaseSyncStore";
import { useSession } from "@clerk/clerk-react";
import axios from "axios";
import { useCallback } from "react";
import { JsxElement } from "./jsx/jsxElementTypes";
import { compressHtml, compressNavTree } from "./navTreeCompression";
import { NavTreeNode } from "./types";
import { base64ToUint8Array, getUnexpiredToken, useCanvasId } from "./utils";

const empty1x1Png = new Blob([
  base64ToUint8Array(
    "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
  ),
  "image/png",
]);

export const useUpdateComponentPreview = () => {
  const { session } = useSession();
  const canvasId = useCanvasId();
  const triggerRefetchElementMetadata = useDatabaseSyncWrapperStore(
    (state) => state.triggerRefetchElementMetadata,
  );
  const updateComponentPreview = useCallback(
    async (
      element: JsxElement,
      imageData: { light: Blob; dark: Blob } | null,
      htmlForInstantUpdate: string | null,
      navTreeForInstantUpdate: NavTreeNode | null,
      width: number | null,
      height: number | null,
    ) => {
      if (!session) {
        return;
      }

      const formData = new FormData();
      formData.append("file", imageData?.light ?? empty1x1Png);
      formData.append("darkFile", imageData?.dark ?? empty1x1Png);
      formData.append("element", JSON.stringify(element));
      if (htmlForInstantUpdate)
        formData.append(
          "htmlForInstantUpdate",
          compressHtml(htmlForInstantUpdate) || "",
        );
      if (navTreeForInstantUpdate)
        formData.append(
          "navTreeForInstantUpdate",
          compressNavTree(navTreeForInstantUpdate) || "",
        );
      if (width) formData.append("width", width.toString());
      if (height) formData.append("height", height.toString());

      const supabaseJWT = await getUnexpiredToken(session);
      await axios.post(
        `${
          import.meta.env.VITE_BACKEND_BASE_URL
        }/canvases/${canvasId}/updateElementPreview`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${supabaseJWT}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      triggerRefetchElementMetadata();
    },
    [session, canvasId, triggerRefetchElementMetadata],
  );
  return updateComponentPreview;
};
